import React from "react";
import {generateRiverFloodExcel} from "../rainFlood/ApiCalls";
import {Button, Dialog, Label, Pane, TextInput, TextInputField, toaster} from "evergreen-ui";
import SmartButton from "../common/SmartButton";
import {generateExcelViaTemplateIdForRiverFlood} from "../decadeConstructor/ApiCalls";
import SuspenseSpinner from "../../../Utils/SuspenseSpinner";
import {onDownloadFileAction} from "../common/OutputFormsDownloadFileFromConstructor";
import {getDefaultNameExactToDaysForRiverFloods, setEndTime, setStartTime} from "../common/DateMethods";
import {MAX_OUTPUT_FORM_NAME_LENGTH} from "../common/OutputFormsConstraints";

export default function CreateOutputFormRiverFloodDialog({constructor, isShown, setIsShown, viaTemplateId= false, id, name}) {
    let [startPeriod, setStartPeriod] = React.useState("")
    let [startPeriodMelting, setStartPeriodMelting] = React.useState("")
    let [endPeriod, setEndPeriod] = React.useState("")
    let [endPeriodMelting, setEndPeriodMelting] = React.useState("")
    let [stationName, setStationName] = React.useState("")

    let [outputFormName, setOutputFormName] = React.useState(stationName + "_")
    let [isOutputFormNameCustom, setIsOutputFormNameCustom] = React.useState(false)

    const [isFetch, setIsFetch] = React.useState(false)

    function updateStationName() {
        setStationName(
            name !== undefined ?
                name !== "" ?
                    name :
                    checkConstructor
                : checkConstructor
        )
    }

    function checkConstructor() {
        return constructor.station.name !== undefined ?
            constructor.station.name !== "" ?
                constructor.station.name :
                ""
            : ""
    }

    function clearDialogFields() {
        setStartPeriod('')
        setEndPeriod('')
        setStartPeriodMelting('')
        setEndPeriodMelting('')
        setIsOutputFormNameCustom(false)
        setOutputFormName(constructor.station.name + "_")
    }

    function createOutputForm() {
        const period = {
            start: startPeriod,
            end: endPeriod
        }

        const meltingPeriod = {
            start: startPeriodMelting,
            end: endPeriodMelting
        }

        if (outputFormName.length > MAX_OUTPUT_FORM_NAME_LENGTH) {
            toaster.danger("Ошибка! Наименование выходной формы не может быть длиннее " + MAX_OUTPUT_FORM_NAME_LENGTH
                +  " символов!")
            setIsFetch(false)
            return;
        }

        if (viaTemplateId) {
            setIsFetch(true)
            generateExcelViaTemplateIdForRiverFlood(id, period, meltingPeriod, getDefaultOutputFormName()).then(() => {
                toaster.success('Файл сохранён!')
                setIsFetch(false)
                clearDialogFields()
            }).catch(() => {
                toaster.danger("Ошибка!")
                setIsFetch(false)
                clearDialogFields()
            })
        } else {
            setIsFetch(true)
            generateRiverFloodExcel(period, meltingPeriod, constructor, getDefaultOutputFormName()).then((response) => {
                toaster.success('Файл сохранён!')
                setIsFetch(false)
                //скачиваем форму сразу
                onDownloadFileAction(response.data.id)
                clearDialogFields()
            }).catch(() => {
                toaster.danger("Ошибка!")
                setIsFetch(false)
                clearDialogFields()
            })
        }
    }

    function isFormButtonDisabled() {
        const start = new Date(startPeriod)
        const end = new Date(endPeriod)
        const dateIncorrect =  startPeriod === "" || endPeriod === ""
            || start - end > 0 || startPeriodMelting === "" || endPeriodMelting === ""

        return (outputFormName.trim().length === 0 && getDefaultOutputFormName().length === 0) || dateIncorrect
    }

    function setCustomOutputFormName(name) {
        setIsOutputFormNameCustom(true)
        setOutputFormName(name)
    }

    function getDefaultOutputFormName() {
        if (isOutputFormNameCustom) {
            return outputFormName
        }

        return getDefaultNameExactToDaysForRiverFloods(
            stationName,
            startPeriod,
            endPeriod,
            startPeriodMelting,
            endPeriodMelting
        )
    }

    function setStartDateWithFormNameSaving(value) {
        updateStationName()
        setStartPeriod(setStartTime(value))

        if (!isOutputFormNameCustom) {
            outputFormName = getDefaultNameExactToDaysForRiverFloods(
                stationName,
                setStartPeriod(setStartTime(value)),
                endPeriod,
                startPeriodMelting,
                endPeriodMelting
            )
        }
    }

    function setStartMeltingDateWithFormNameSaving(value) {
        updateStationName()
        setStartPeriodMelting(setStartTime(value))

        if (!isOutputFormNameCustom) {
            outputFormName = getDefaultNameExactToDaysForRiverFloods(
                stationName,
                startPeriod,
                endPeriod,
                setStartPeriodMelting(setStartTime(value)),
                endPeriodMelting
            )
        }
    }

    function setEndDateWithFormNameSaving(value) {
        updateStationName()
        setEndPeriod(setEndTime(value))

        if (!isOutputFormNameCustom) {
            outputFormName = getDefaultNameExactToDaysForRiverFloods(
                stationName,
                startPeriod,
                setEndPeriod(setEndTime(value)),
                startPeriodMelting,
                endPeriodMelting
            )
        }
    }

    function setEndMeltingDateWithFormNameSaving(value) {
        updateStationName()
        setEndPeriodMelting(setEndTime(value))

        if (!isOutputFormNameCustom) {
            outputFormName = getDefaultNameExactToDaysForRiverFloods(
                stationName,
                startPeriod,
                endPeriod,
                startPeriodMelting,
                setEndPeriodMelting(setEndTime(value))
            )
        }
    }

    return (
        <Dialog
            isShown={isShown}
            title="Формирование выходной формы"
            onOpenComplete={() => {
                setOutputFormName(stationName + "_")
            }}
            onCloseComplete={() => {
                clearDialogFields()
                setIsShown(false)
            }}
            footer={
                <Pane>
                    <Button marginRight={5} onClick={() => setIsShown(false)}>Отменить</Button>
                    <SmartButton
                        disabledTooltip={"Заполните все поля формы"}
                        buttonText={"Сформировать"}
                        isPrimary={true}
                        isDisabled={isFormButtonDisabled()}
                        onClickAction={() => createOutputForm()}
                    />
                </Pane>
            }

        >
            {isFetch ? <SuspenseSpinner/> : <Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату начала половодья</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="startDate"
                            max={endPeriod}
                            onChange={val => {
                                setStartDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату окончания половодья</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="endDate"
                            min={startPeriod}
                            onChange={val => {
                                setEndDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату начала снеготаяния</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="startDate"
                            onChange={val => {
                                setStartMeltingDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane display={"flex"} columnGap={10} marginBottom={15}>
                    <Pane width={250}>
                        <Label>Выберите дату окончания снеготаяния</Label>
                    </Pane>

                    <Pane>
                        <TextInput
                            width={155}
                            type="date"
                            name="endDate"
                            onChange={val => {
                                setEndMeltingDateWithFormNameSaving(val.target.value)
                            }}
                        />
                    </Pane>
                </Pane>
                <Pane marginRight={30} marginTop={30}>
                    <TextInputField
                        label="Введите наименование выходной формы"
                        width={415}
                        value={getDefaultOutputFormName()}
                        onChange={e => setCustomOutputFormName(e.target.value)}
                    />
                </Pane>
            </Pane>}
        </Dialog>
    )
}